import { render, staticRenderFns } from "./reporting.vue?vue&type=template&id=3879ebb2&scoped=true"
import script from "./reporting.vue?vue&type=script&lang=js"
export * from "./reporting.vue?vue&type=script&lang=js"
import style0 from "./reporting.vue?vue&type=style&index=0&id=3879ebb2&prod&lang=scss&scoped=true"
import style1 from "./reporting.vue?vue&type=style&index=1&id=3879ebb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3879ebb2",
  null
  
)

export default component.exports